export function ReturnBackArrowIcon({
  className = 'text-fx-neutral-600',
}: {
  className?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17 15.1621H11.4228C9.67988 15.1621 10.0285 13.0429 10.0285 11.6161C10.0285 10.0725 10.0285 8.42888 10.0285 7M17 15.1621L14.2114 12.3242M17 15.1621L14.2114 18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
